import React, {Component} from 'react';
import PropTypes from 'prop-types';
import decl from '../../helpers/declension';
import Input from '../../../input';
import Checkbox from '../../../checkbox';
import BonusDrag from '../../bonusDrag';
import FooterIcon from '../../footer/icon';
import {setCookie, monthTimeout} from '../../../../helpers/cookie';
import {
  isEmailDomainValid,
  isEmailLocalPartValid,
  getEmailDomainSuggestion,
} from '../../../../helpers/email';
import {render, unmountComponentAtNode as remove} from 'react-dom';
import Popup from '../../../popup';

import Timer from '../../timer';
import Api from "../../../../helpers/api";

window.addEventListener(
  'message',
  function (e) {
    switch (e.data) {
      case 'close':
        render(
          <Popup
            type="alert"
            status="success"
            title="Заказ оплачен"
            message="Посмотреть свои билеты вы можете в профиле"
            button="Перейти в профиль"
            link="/profile"
          />,
          $('#popup')[0],
        );
        break;
      case 'ticketTimeout':
        render(
          <Popup
            type="alert"
            status="error"
            title="Заказ не оплачен"
            message="Время ожидания оплаты заказа истелко"
            button="Перейти к расписанию сеансов"
            link="/"
          />,
          $('#popup')[0],
        );
        break;
      default:
        break;
    }
  },
  false,
);

// Оплата покупки билета
export const renderBankIframe = url => {
  const bankIframe = () => {
    // ticket payment timeout ~6min 50sec
    const paymentTimeout = 410000;
    const expire =
      window.expire_date != null
        ? window.expire_date
        : Date.now() + paymentTimeout;

    return (
      <React.Fragment>
        <Timer expireAtMs={expire} enable={true}/>
        <div className="bank-popup">
          <div className="bank-popup__head">
            <button className="scheme-popup__close" type="button">
              <svg viewBox="0 0 18 18" width="18" height="18">
                <path
                  d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"/>
              </svg>
            </button>
          </div>
          <iframe
            title="bank payment"
            name="bank_iframe"
            id="bank_iframe"
            src={url}
            class="sberIframe"
            scrolling="auto"
            frameBorder="0"
          />
          ;
        </div>
      </React.Fragment>
    );
  };

  render(bankIframe(), $('#popup')[0]);
};

class Checkout extends Component {
  static propTypes = {
    selected: PropTypes.array,
    session: PropTypes.object,
    sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    route: PropTypes.shape({
      buy: PropTypes.string,
    }).isRequired,
    checkout: PropTypes.object,
    returnError: PropTypes.func,
    amount: PropTypes.number,
    maxBonusPay: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      agreementAccepted: false,
      personalDataAccepted: false,
    };

    this.orderId = null;
    this.userId = null;
  }

  isUserAuthorized = () => {
    const { user } = this.props;
    return user && user.user_id;
  };

  getValidationState = () => {
    const {
      checkout: {phone, email},
    } = this.props;

    const phoneDigits = phone ? phone.replace(/\D/g, '') : '';
    const phoneError = Boolean(phone) && phoneDigits.length !== 11;

    const hasEmail = Boolean(email);
    const emailPatternValid = hasEmail && /\S+@\S+\.\S+/.test(email);
    const emailLocalPart = emailPatternValid ? email.split('@')[0] : '';
    const emailLocalValid = emailPatternValid && isEmailLocalPartValid(emailLocalPart);
    const emailDomainValid = emailPatternValid && isEmailDomainValid(email);
    const emailReady =
      hasEmail && emailPatternValid && emailLocalValid && emailDomainValid;
    const emailInvalid = !emailReady;
    const emailError = hasEmail && !emailReady;

    const emailSuggestion =
      emailPatternValid && emailLocalValid && !emailDomainValid
        ? getEmailDomainSuggestion(email)
        : null;

    return {phoneError, emailError, emailSuggestion, emailInvalid};
  };

  applyEmailSuggestion = suggestion => {
    if (suggestion) {
      this.props.onEditCheckout('email', suggestion);
    }
  };

  // Проверка перед оплатой
  checkInputs() {
    const { agreementAccepted, personalDataAccepted } = this.state;
    const isAuthorized = this.isUserAuthorized();
    const {phoneError, emailInvalid} = this.getValidationState();

    return !(
      phoneError ||
      emailInvalid ||
      (!isAuthorized && (!agreementAccepted || !personalDataAccepted))
    );
  }

  // запрос на создание заказа - ответ варианты оплаты
  createOrderbuy = () => {
    const {
      selected,
      returnError,
      sessionId,
      checkout: {phone, email, bonusPay},
    } = this.props;

    const formData = new FormData();

    formData.append('phone', phone.replace(/\D/g, ''));
    formData.append('email', email);
    formData.append('session', sessionId);
    formData.append('seats', selected);
    formData.append('bonus_pay', bonusPay);

    const api = new Api();

    this.setState({
      loading: true,
    });

    return api
      .createOrder(formData)
      .then(response => response.json())
      .then(json => {
        if (json.status === 'success') {
          if (json.data.url) {
            this.setState({
              loading: false,
            });
            window.location.href = json.data.url;
          } else {
            if (json.data['order-id']) {
              this.orderId = json.data['order-id'];
              setCookie('ORDER_ID', json.data['order-id']);
              this.userId = json.data['user-id'];
              // console.log(this.orderId);
              this.props.setOrderId(this.orderId);
              setCookie('UNPAID_ORDER', 'TRUE');
            }
            if (json.data.expire_date_unix) {
              const extraPaymentTimeout = 10000;
              window.expire_date =
                json.data.expire_date_unix * 1000 - extraPaymentTimeout;
            }
            if (json.data.payment.methods) {
              this.props.setDataPaymentMethods(json.data);
              const cinemaPaymentMethods = Object.keys(
                json.data.payment.methods,
              );
              return new Promise(resp => resp(cinemaPaymentMethods));
            }
          }
        } else if (json.data.available || json.errors) {
          const err = json.errors;
          returnError([err]);
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  buyTicketsSber = () => {
    const data = {
      'order-id': this.orderId,
      'pay-method': 'card',
    };
    const headers = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (process.env.NODE_ENV !== 'dev') {
      headers.credentials = 'include';
    }

    this.setState({
      loading: true,
    });

    clearTimeout(window.closePopupInterval);

    const route = '/local/php_interface/api/v2/payment/pay/';

    // try to buy a ticket
    fetch(route, headers)
    .then(response => response.json())
    .then(json => {
      if (json.status === 'success') {
        if (json.data.bonus_order) {
          this.setState({
            loading: false,
          });
        } else {
          if (json.data.redirect_url !== '') {
            setCookie('UNPAID_ORDER', 'TRUE');
            setCookie('PAYMENT_LINK', json.data.redirect_url);
            setCookie('PAYMENT_METHOD', 'card');
            setCookie('userChooseInfo', 0, monthTimeout);

            // renderBankIframe(json.data.redirect_url);
            window.location.href = json.data.redirect_url;
          }

          // close popup
          window.closePopupInterval = setTimeout(() => {
            if ($('#bank_iframe').length > 0) {
              window.postMessage('ticketTimeout', '*');
            }
          }, window.expire_date - Date.now());

          this.setState({
            loading: false,
          });
        }
      } else if (json.data.available || json.errors) {
        const err = json.errors;
        returnError([err]);
      }
    })
    .catch(() => {
      this.setState({
        loading: false,
      });
    });
  };

  getGooglePaymentsClient() {
    if (this.googlePaymentsClient === null) {
      this.googlePaymentsClient = new google.payments.api.PaymentsClient({
        environment: 'PRODUCTION',
      });
    }
    return this.googlePaymentsClient;
  }

  baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
  };

  allowedCardNetworks = ['MASTERCARD', 'VISA'];
  allowedCardAuthMethods = ['CRYPTOGRAM_3DS'];

  baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: this.allowedCardAuthMethods,
      allowedCardNetworks: this.allowedCardNetworks,
    },
  };

  checkGooglePayMethod = () => {
    const paymentsClient = this.getGooglePaymentsClient();
    const isReadyToPayRequest = Object.assign({}, this.baseRequest);
    isReadyToPayRequest.allowedPaymentMethods = [this.baseCardPaymentMethod];
    paymentsClient
    .isReadyToPay(isReadyToPayRequest)
    .then(function (response) {
      if (response.result) {
        return true;
      }
    })
    .catch(function (err) {
      return false;
      // show error in developer console for debugging
      console.error(err);
    });
  };

  // проверка пользователя на доступные способы оплаты
  checkUserPaymentMethods = () => {
    this.createOrderbuy().then(cinemaPaymentMethods => {
      const userPaymentMethods = ['card'];
      clearTimeout(window.closePopupInterval);
      this.props.enableTimerCallback(true);

      // const usersId = ['31', '28', '30', '41063', '3715', '3716', '245342'];
      // if (usersId.includes(this.userId)) {
      //   userPaymentMethods.push('google');
      // }

      cinemaPaymentMethods.forEach(pymentMethod => {
        if (pymentMethod === 'pushkin_card') {
          userPaymentMethods.push('pushkin_card');
        }
        /*
        if (pymentMethod === 'apple' && window.ApplePaySession) {
          userPaymentMethods.push('apple');
        }
        if (pymentMethod === 'google' && this.checkGooglePayMethod) {
          userPaymentMethods.push('google');
        }
        */
        if (pymentMethod === 'sbp') {
          userPaymentMethods.unshift('sbp');
        }
      });

      this.props.setForUserPaymentMethods(userPaymentMethods);
      userPaymentMethods.length > 1
        ? this.props.onChoicePayment()
        : this.buyTicketsSber();
    });
  };

  // проверка кол-ва вариантов оплаты - если больше 1,
  // то выводит окно выбора оплаты, меньше - выводит окно сбербанка
  allowedPaymentMethods = () => {
    this.checkUserPaymentMethods();
  };

  cancelSvg() {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M10.9999 5.5C10.7147 5.4892 10.4327 5.56064 10.1901 5.70514C9.94748 5.84964 9.75534 6.06061 9.63838 6.31092C9.52142 6.56123 9.48498 6.83945 9.53373 7.10983C9.58249 7.38021 9.71422 7.63039 9.91199 7.82823C10.1098 8.02607 10.3645 8.16252 10.6436 8.22005C10.9226 8.27758 11.2132 8.25356 11.478 8.15108C11.7427 8.04859 11.9695 7.87233 12.1293 7.64494C12.289 7.41755 12.3744 7.14941 12.3745 6.875C12.3804 6.51779 12.2392 6.17282 11.9817 5.91526C11.7242 5.6577 11.3713 5.50844 10.9999 5.5ZM10.9999 9.625C10.6283 9.63322 10.2752 9.78239 10.0175 10.04C9.75984 10.2975 9.61855 10.6426 9.62446 11V15.125C9.61632 15.3035 9.64586 15.4817 9.71129 15.649C9.77672 15.8162 9.87669 15.9689 10.0052 16.098C10.1337 16.2271 10.288 16.3298 10.4589 16.4C10.6298 16.4701 10.8136 16.5063 10.9995 16.5063C11.1853 16.5063 11.3692 16.4701 11.54 16.4C11.7109 16.3298 11.8653 16.2271 11.9937 16.098C12.1222 15.9689 12.2222 15.8162 12.2876 15.649C12.3531 15.4817 12.3826 15.3035 12.3745 15.125V11C12.3804 10.6428 12.2392 10.2978 11.9817 10.0403C11.7242 9.7827 11.3713 9.63344 10.9999 9.625Z"
            fill="#E41A69"
          />
          <path
            d="M10.9999 0C8.02564 0.0604513 5.19764 1.25225 3.13571 3.31418C1.07377 5.37612 -0.0538858 8.13998 -0.000114715 11C-0.0538858 13.86 1.07377 16.6239 3.13571 18.6858C5.19764 20.7477 8.02564 21.9395 10.9999 22C13.9741 21.9395 16.8021 20.7477 18.8641 18.6858C20.926 16.6239 22.0537 13.86 21.9999 11C22.0537 8.13998 20.926 5.37612 18.8641 3.31418C16.8021 1.25225 13.9741 0.0604513 10.9999 0V0ZM10.9999 19.9379C8.58326 19.8888 6.28546 18.9204 4.61016 17.245C2.93486 15.5696 2.01874 13.3238 2.06261 11C2.01898 8.67633 2.9352 6.4308 4.61047 4.75556C6.28575 3.08032 8.58341 2.11204 10.9999 2.06292C13.4164 2.11204 15.714 3.08032 17.3893 4.75556C19.0646 6.4308 19.9808 8.67633 19.9372 11C19.981 13.3238 19.0649 15.5696 17.3896 17.245C15.7143 18.9204 13.4165 19.8888 10.9999 19.9379Z"
            fill="#E41A69"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="22" height="22" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    );
  }

  render() {
    const {selected, session, checkout, amount, user, maxBonusPay} = this.props;

    const {loading} = this.state;
    const {phoneError, emailError, emailSuggestion} = this.getValidationState();
    const emailSuggestionNode = emailSuggestion ? (
      <span>
        Возможно, вы имели в виду{' '}
        <button
          type="button"
          className="inp__note-link"
          onClick={() => this.applyEmailSuggestion(emailSuggestion)}
        >
          {emailSuggestion}
        </button>
        ?
      </span>
    ) : null;
    const emailErrorText =
      emailSuggestionNode || (emailError ? 'Введите корректный e-mail' : null);

    const choosedTicketClasses = ['hint__tickets'];
    if (selected.length) choosedTicketClasses.push('hint__tickets--active');

    const choosedTicketText = selected.length
      ? `${selected.length} ${decl(selected.length, [
        'билет',
        'билета',
        'билетов',
      ])} за ${amount - checkout.bonusPay} руб.`
      : `Выберите места`;

    const btnClasses = ['btn', 'btn--accent'];

    if (!this.checkInputs()) btnClasses.push('btn--disable');
    if (loading) btnClasses.push('btn--loading');

    return (
      <div className="buy-checkout-side__container">
        {/* mobile version */}
        <div className="scheme-popup__top">
          <button
            className="scheme-popup__top-btn left"
            type="button"
            onClick={() => {
              this.props.onBackClick();
            }}
          >
            <svg
              className="icon--shev"
              width="10"
              height="15"
              viewBox="0 0 5 8"
            >
              <path
                d="M3.6 7.8c.2.1.4.2.6.2.4 0 .8-.4.8-.9 0-.2-.1-.4-.3-.6l-2.6-2.5 2.6-2.5c.2-.2.3-.4.3-.6 0-.5-.4-.9-.8-.9-.2 0-.4.1-.6.2l-3.3 3.1c-.3.3-.4.9 0 1.2l3.3 3.3z"/>
            </svg>
          </button>
          <h4 className="heading heading--2">Оформление заказа</h4>
        </div>

        {/* desktop version */}
        <button
          onClick={() => this.props.onBackClick()}
          className="buy-checkout-side__back"
        >
          <svg width="8" height="5">
            <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down"></use>
          </svg>
          Назад
        </button>
        <h4 className="buy-checkout-side__title">
          Данные для получения заказа
        </h4>

        <div className="buy-checkout-side__inp-container">
          <Input
            label="Номер телефона"
            name="phone"
            phone
            error={phoneError}
            placeholder="Пришлем номер заказа"
            value={checkout.phone ? checkout.phone : ''}
            disable={user.phone ? true : false}
            onChange={(val, name) => this.props.onEditCheckout(name, val)}
          />
          <Input
            label={session.cinema.id === 6 ? "E-mail (для чека и qr-кода парковки)" : "E-mail"}
            name="email"
            error={emailError}
            errorText={emailErrorText}
            placeholder="Пришлем электронный чек"
            value={checkout.email ? checkout.email : ''}
            disable={user.email ? true : false}
            onChange={(val, name) => this.props.onEditCheckout(name, val)}
          />
        </div>
        {!this.isUserAuthorized() && (
          <div className="buy-checkout-side__checkboxes">
            <Checkbox
              key="agreement-checkout-v1-1"
              checked={this.state.agreementAccepted}
              value={this.state.agreementAccepted ? 1 : 0}
              name="agreement"
              label={
                <span>
                  Согласен с{' '}
                  <a href="/help/" target="_blank" className="link accent">
                    пользовательским соглашением
                  </a>
                </span>
              }
              onChange={value =>
                this.setState({ agreementAccepted: value === 1 })
              }
              required
            />
            <Checkbox
              key="personalData-checkout-v1-1"
              checked={this.state.personalDataAccepted}
              value={this.state.personalDataAccepted ? 1 : 0}
              name="personalData"
              label={
                <span>
                  Согласен с{' '}
                  <a href="/help/" target="_blank" className="link accent">
                    обработкой персональных данных
                  </a>
                </span>
              }
              onChange={value =>
                this.setState({ personalDataAccepted: value === 1 })
              }
              required
            />
          </div>
        )}
        {!session.cinema.no_bonus && user.card && !session.no_bonus > 0 && (
          <BonusDrag
            amount={amount}
            maxBonusPay={maxBonusPay}
            balance={user.balance}
            count={checkout.bonusPay}
            changeBonusCount={val => this.props.onEditCheckout('bonusPay', val)}
            disable={false}
          />
        )}
        {session.no_bonus && (   
          <p style={{color:"#e41a69", fontSize:"14px", marginBottom:"15px"}}>Бонусная система не распространяется на события организаторов акции/мероприятия, арендующих залы кинотеатра</p>
        )}
        <FooterIcon
          cinema={session.cinema}
          user={user}
          onLogin={() => this.props.onLogin()}
        />

        <div className="hint-link">
          <p className="hint-link__txt">
            {this.cancelSvg()}
            <span>Правила покупки и отмены</span>
          </p>
          <div className="hint-link__popover">
            <p>При оплате бонусами минимальная стоимость каждого билета - 1 рубль.</p>
            <p>Отменить билеты можно не позднее, чем за 30 минут до начала санса через
              &nbsp;<a href="http://app.comfortkino.ru" target="_blank">приложение</a> или
              &nbsp;<a href="/profile" onClick={e => this.props.saveUserChoose(e)}>личный&nbsp;кабинет</a>
              &nbsp;на сайте.</p>
          </div>
        </div>
        <div className="checkout-result__wrapper">
          <button
            className={choosedTicketClasses.join(' ')}
            onClick={() => this.props.showTooltip()}
          >
            {choosedTicketText}
          </button>
          <button
            className={btnClasses.join(' ')}
            type="button"
            onClick={() => {
              this.allowedPaymentMethods();
            }}
          >
            <span>Купить билеты</span>
          </button>
        </div>
      </div>
    );
  }
}

export default Checkout;
